(function () {
  function slugify(text) {
    return text
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function initTOC() {
    var widget = document.getElementById('toc-widget');
    if (!widget) return;

    // Artikel-Content-Bereich finden (Focal-spezifisch)
var articleBody =
  document.querySelector('.article-template-content') ||
  document.querySelector('.article-template-content.rte') ||
  document.querySelector('.rte') ||
  document.querySelector('article');

    if (!articleBody) {
      widget.classList.add('toc-widget--hidden');
      return;
    }

    var headings = articleBody.querySelectorAll('h2, h3');

    if (headings.length < 2) {
      widget.classList.add('toc-widget--hidden');
      return;
    }

    var ol = document.getElementById('toc-widget__ol');
    var usedSlugs = {};

    headings.forEach(function (heading) {
      var text = heading.textContent.trim();
      var baseSlug = slugify(text);

      // Eindeutige IDs sicherstellen
      var slug = baseSlug;
      if (usedSlugs[slug]) {
        usedSlugs[slug]++;
        slug = baseSlug + '-' + usedSlugs[slug];
      } else {
        usedSlugs[slug] = 1;
      }

      // ID am Heading setzen (nur wenn noch keine vorhanden)
      if (!heading.id) {
        heading.id = slug;
      } else {
        slug = heading.id;
      }

      var li = document.createElement('li');
      li.className =
        heading.tagName === 'H3'
          ? 'toc-widget__item--h3'
          : 'toc-widget__item--h2';

      var a = document.createElement('a');
      a.href = '#' + slug;
      a.textContent = text;

      // Smooth scroll
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById(slug);
        if (!target) return;
        var offset = 80; // Sticky-Header-Höhe anpassen falls nötig
        var top =
          target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
        // URL-Hash setzen ohne Sprung
        history.pushState(null, null, '#' + slug);
      });

      li.appendChild(a);
      ol.appendChild(li);
    });

    // Toggle-Logik
    var toggle = widget.querySelector('.toc-widget__toggle');
    var body = document.getElementById('toc-widget__list');

    toggle.addEventListener('click', function () {
      var isOpen = widget.hasAttribute('data-open');
      if (isOpen) {
        widget.removeAttribute('data-open');
        toggle.setAttribute('aria-expanded', 'false');
        body.setAttribute('aria-hidden', 'true');
      } else {
        widget.setAttribute('data-open', '');
        toggle.setAttribute('aria-expanded', 'true');
        body.setAttribute('aria-hidden', 'false');
      }
    });

    // Standardmäßig offen? Einstellbar via data-Attribut
    if (widget.dataset.defaultOpen === 'true') {
      widget.setAttribute('data-open', '');
      toggle.setAttribute('aria-expanded', 'true');
      body.setAttribute('aria-hidden', 'false');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTOC);
  } else {
    initTOC();
  }
})();